const NavigateToAnotherLink = ({link}) => {
  window.location.href = link;
  return null;
};

export default NavigateToAnotherLink;
